<template>
  <div
    class="relative group bg-white dark:bg-gray-800 p-5 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:shadow-sm transition-all cursor-pointer"
    @click="handleCardClick">
    <div class="flex items-start justify-between">
      <div class="flex-1 min-w-0">
        <h3 class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
          {{ business.name }}
        </h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {{ business.city }}, {{ business.state }}
        </p>
        <div class="mt-3 flex items-center text-sm text-gray-500 dark:text-gray-400">
          <i class="fas fa-map-marker-alt mr-1.5" />
          {{ business.locations_count || 0 }} locations
        </div>
      </div>
      <div v-if="business.logo" class="ml-4 flex-shrink-0">
        <img
          :src="business.logo"
          :alt="business.name"
          class="h-12 w-12 rounded-lg object-cover">
      </div>
      <div
        v-else
        class="ml-4 flex-shrink-0 h-12 w-12 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
        <i class="fas fa-building text-gray-400 dark:text-gray-500" />
      </div>
    </div>

    <!-- Action buttons -->
    <div class="absolute top-2 right-2 flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
      <button
        v-if="!business.archived_at"
        @click.stop="$emit('edit', business)"
        class="p-1.5 rounded-md bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 shadow-sm border border-gray-300 dark:border-gray-600"
        title="Edit Business">
        <i class="fas fa-edit text-xs" />
      </button>

      <a
        v-if="business.website_id && !business.archived_at"
        :href="`/businesses/${business.id}/website/website_pages`"
        @click.stop
        class="p-1.5 rounded-md bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 shadow-sm border border-gray-300 dark:border-gray-600"
        title="Manage Website Pages">
        <i class="fas fa-file-alt text-xs" />
      </a>

      <span
        v-if="business.archived_at"
        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
        Archived
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  business: {
    type: Object,
    required: true,
    validator: (value) => value && typeof value.name === 'string'
  }
})

const emit = defineEmits(['click', 'edit'])

const handleCardClick = (event) => {
  // Don't emit click if clicking on action buttons or links
  if (!event.target.closest('button') && !event.target.closest('a')) {
    emit('click', props.business)
  }
}
</script>
